<template>
  <myHome v-if="!is_mobile"></myHome>
  <myHomeMobile v-if="is_mobile" isMobile="isMobile"></myHomeMobile>
</template>

<script>
import myHome from "./components/myHome.vue";
import myHomeMobile from "./components/myHome-mobile.vue";
import { isMobile } from "./common/utils";
export default {
  name: "App",
  components: {
    myHome,
    myHomeMobile,
  }, //,myHome_m
  data() {
    return {
      is_mobile: false,
    };
  },
  mounted() {
    this.is_mobile = isMobile();
  },
};
</script>

<style>
#app {
  width: 100%;
}
</style>
